export default class GoodsModel {
  constructor () {
    this.차종 = null
    this.품번 = null
    this.납입품번 = null
    this.품명 = null
    this.품목유형 = null
    this.자재유형 = null
    this.공정유형 = null
    this.재질 = null
    this.외주가공비 = null
    this.판매가공비 = null
    this.표준공수 = null
    this.cycletime = null
    this.주문lot = null
    this.규격 = null
    this.단위 = null
    this.구매단위 = null
    this.변환배율 = null
    this.거래처코드 = null
    this.납품처코드 = null
    this.납품장소 = null
    this.담당부서 = null
    this.라인코드 = null
    this.parentId = null
    this.수량 = null
  }
}
